import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { DataCourse } from '../shared/interfaces/course.interface';

const HOST = environment.host;

@Injectable({
  providedIn: 'root'
})
export class InsigniasService {
  insignias: any;

  constructor(private http: HttpClient) { }

  getInsigniasOfStudent(idCourse:number, idStudent:number): Observable<any>{
    const URL = `${HOST}/api/Insignias/${idCourse}/${idStudent}`;
    return this.http.get(URL)
  }

  searchInsignia(uidInsignia:string): Observable<DataCourse>{
    const URL = `${HOST}/api/taxonomy_term/insignias/${uidInsignia}`;
    return this.http.get<any>(URL).pipe(
      map( resp=> resp.data)
    )
  }
}
